import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { nanoid } from '@reduxjs/toolkit';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import colors from '../../../../../scss/colors';

function FilterChips({ selectedFilter, setSelectedFilter, changeHandler }) {
  const handleDelete = (item, field) => {
    const newData = selectedFilter?.[field]?.filter((i) => i !== item);
    setSelectedFilter({
      ...selectedFilter,
      [field]: newData
    });
    changeHandler({ target: { value: selectedFilter[field].filter((filter) => filter !== item) } }, field);
  };

  const GenerateChips = (filterName) => {
    const filterPeriods = useSelector((state) => state.constFromApi.filterPeriods);

    return selectedFilter?.[filterName]?.map((item) => (
      <Chip
        sx={{
          border: `1px solid ${colors.PRIMARY_BLUE}`
        }}
        deleteIcon={
          <CloseIcon
            style={{
              color: colors.PRIMARY_BLUE
            }}
          />
        }
        key={nanoid()}
        label={filterName === 'date_posted' ? filterPeriods.find((filter) => filter?.value === item)?.label : item}
        variant="outlined"
        onDelete={() => handleDelete(item, filterName)}
      />
    ));
  };

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {GenerateChips('function')}
      {GenerateChips('industry')}
      {GenerateChips('contract_type')}
      {GenerateChips('date_posted')}
    </Stack>
  );
}
export default FilterChips;
